import type { FacilityType, Resources, ShipType } from '@stars-and-ships/api-types';

export const SYSTEM_TABS = ['buildings', 'shipyard', 'port', 'embassy'] as const;
export type SystemTab = (typeof SYSTEM_TABS)[number];

export const parseSystemTab = (value: string | null): SystemTab =>
  SYSTEM_TABS.find((t) => t === value) ?? 'buildings';

/** What is in flight. Only the pressed control shows it; every other action stays usable (spec §3.8). */
export interface PendingActions {
  upgrade?: FacilityType | undefined;
  cancel?: string | undefined;
  trade?: boolean;
  produce?: boolean;
  cancelProduction?: string | undefined;
}

/** What Finish now needs (P37); absent where there is no wallet to show. */
export interface FinishNowContext {
  galaxyId: string;
  darkMatter: number;
  darkMatterPerHour: number;
}

export interface SystemActions {
  upgrade(facility: FacilityType): void;
  cancel(itemId: string): void;
  trade(resources: Resources): void;
  produce(shipType: ShipType, quantity: number): void;
  cancelProduction(itemId: string): void;
  pending: PendingActions;
  error: unknown;
  finishNow?: FinishNowContext;
}
